module.exports = __webpack_public_path__ + "static/media/24UHCHR10.7a2ae281.jpg";